import { createApp } from 'vue';
import WavToOpusConverter from '@/Components/WavToOpusConverter.vue';
import '@styles/app.css';

createApp(WavToOpusConverter).mount('#wav-to-opus-converter');
